import { breakpoints } from '@bnnvara/breakpoints';
import styled from 'styled-components';

export const BaseMetaBlockDataContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const CategoryContainer = styled.div`
  a {
    color: ${({ theme }) => theme.primary.main};
    text-decoration: underline;
    margin-right: 5px;
    font-size: 1.125rem;
  }
  span {
    color: ${({ theme }) => theme.base.black};
  }
`;

export const BaseMetaBlockText = styled.p`
  font-weight: normal;
`;

export const DateTimeContainer = styled.div`
  display: flex;
  flex-direction: column;

  ${breakpoints.md} {
    flex-direction: row;
  }
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 8px;
  flex-wrap: wrap;
  line-height: 0;
  ${breakpoints.md} {
    flex-wrap: no-wrap;
  }
`;

export const Dot = styled.div`
  display: none;

  ${breakpoints.md} {
    display: inline-block;
  }
`;
